// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import md5 from 'js-md5'
import VueCookie from 'vue-cookie';

import {getRequest,postRequest,deleteRequest,putRequest} from './config/requestType'

// 引用cookie


// Tell Vue to use the plugin
Vue.use(VueCookie);

//  引用VUEX 
import Vuex from 'vuex'
import store from './store'
Vue.use(Vuex)

// 引入elementUI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

// 引入 iconfont
import './assets/iconfont/iconfont.css';

// // // 创建基本的axios配置
Vue.prototype.getRequest = getRequest;
Vue.prototype.postRequest = postRequest;
Vue.prototype.deleteRequest = deleteRequest;
Vue.prototype.putRequest = putRequest;
Vue.prototype.md5 = md5;

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js